/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CountActiveIntegrationEvents200Response
 */
export interface CountActiveIntegrationEvents200Response {
    /**
     * 
     * @type {number}
     * @memberof CountActiveIntegrationEvents200Response
     */
    data?: number;
}

/**
 * Check if a given object implements the CountActiveIntegrationEvents200Response interface.
 */
export function instanceOfCountActiveIntegrationEvents200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CountActiveIntegrationEvents200ResponseFromJSON(json: any): CountActiveIntegrationEvents200Response {
    return CountActiveIntegrationEvents200ResponseFromJSONTyped(json, false);
}

export function CountActiveIntegrationEvents200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CountActiveIntegrationEvents200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : json['data'],
    };
}

export function CountActiveIntegrationEvents200ResponseToJSON(value?: CountActiveIntegrationEvents200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
    };
}

